import React from 'react';
import { useFormContext } from 'react-hook-form';

const Step6Billing: React.FC = () => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <div className="solar-form-section">
      <div className="solar-form-group">
        <label htmlFor="averageMonthlyBill" className="solar-form-label">
          Average Monthly Electric Bill
        </label>
        <select
          id="averageMonthlyBill"
          {...register('averageMonthlyBill')}
          className="solar-form-select"
        >
          <option value="">Select bill range</option>
          <option value="0-100">$0 - $100</option>
          <option value="100-200">$100 - $200</option>
          <option value="200-300">$200 - $300</option>
          <option value="300+">$300+</option>
        </select>
        {errors.averageMonthlyBill && (
          <p className="solar-form-error">{String(errors.averageMonthlyBill.message)}</p>
        )}
      </div>

      <div className="solar-form-group">
        <label htmlFor="additionalInfo" className="solar-form-label">
          Additional Information
        </label>
        <textarea
          id="additionalInfo"
          {...register('additionalInfo')}
          rows={4}
          className="solar-form-textarea"
          placeholder="Any additional information about your energy needs..."
        />
        {errors.additionalInfo && (
          <p className="solar-form-error">{String(errors.additionalInfo.message)}</p>
        )}
      </div>
    </div>
  );
};

export default Step6Billing; 